import { useEffect } from 'react'
import type { CSSProperties } from 'react'
import { AdtSplashLogo } from './AdtSplashLogo'
import { useDismissStaticShellSplash } from './useDismissStaticShellSplash'
import { shellSplashTheme, type ShellSplashVariant } from './shellSplashTheme'

type ShellSplashProps = Readonly<{
  variant?: ShellSplashVariant
}>

export function ShellSplash({ variant }: ShellSplashProps) {
  useDismissStaticShellSplash()
  const theme = shellSplashTheme(variant)

  useEffect(() => {
    const previous = document.body.style.backgroundColor
    document.body.style.backgroundColor = theme.background
    return () => {
      document.body.style.backgroundColor = previous
    }
  }, [theme.background])

  const overlayStyle: CSSProperties = {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.background,
    margin: 0,
    zIndex: 9999,
  }

  return (
    <div
      data-testid="shell-splash"
      data-shell-splash-variant={theme.variant}
      style={overlayStyle}
    >
      <AdtSplashLogo size={120} clipPathId="adt-splash-clip-react" fill={theme.logoFill} />
    </div>
  )
}
